// @flow
import { makeStyles } from "@material-ui/styles";
export default makeStyles(() => ({
  container: {
    flexBasis: "20%",
    zIndex: 0
  },
  black: { backgroundColor: "black" },
  big: { flexBasis: "100%" },
  screen: { flexBasis: "80%" },
  hidden: { display: "none" }
}));